import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import Verified from './pages/optum-page/clearme/Verified';
import Login from './pages/login/Login';
import Swal from "sweetalert2";
import { PageLayout } from './pages/PageLayout';
import Redirect from './pages/login/Redirect';
import OTPProgressPage from './pages/otp-progress/OTPProgressPage';

function NotFound() {
  return <h1>404: Page Not Found</h1>;
}

const Pages = () => {

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 401) {
      // Handle 401 Unauthorized error
      console.error('Unauthorized: 401, session timed out or invalid credentials');

      Swal.fire({
        title: "Error",
        text: "Session Timedout, Please login again.",
        confirmButtonText: "OK",
      })
      .then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/login';
          }
      });
    }

    return response;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage window={window} />} />
        <Route path="/clearme/verified" element={<Verified />} />
        <Route path="/otp-progress" element={<OTPProgressPage />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/login" element={<Login />} />
        <Route path="/redirect" element={<Redirect />} />
      </Routes>
    </Router>
  );
}

const App = ({ instance }) => {
  return (
      <div className="App">
        <PageLayout>
            <Pages />
        </PageLayout>
      </div>
  );
};

export default App;